var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};


export {$442f5f6ac211e29f$exports as default};
//# sourceMappingURL=es-ES.module.js.map
